export var GroupingType;
(function (GroupingType) {
    GroupingType["Total"] = "total";
    GroupingType["Action"] = "action";
    GroupingType["EventExtra"] = "eventExtra";
    GroupingType["UserExtra"] = "userExtra";
    GroupingType["UserProperty"] = "userProperty";
})(GroupingType || (GroupingType = {}));
export class Grouping {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
Grouping.$inject = ['init'];
